import Vue from 'vue'
import App from './pages/App.vue'
import router from './router.coffee'
import localisation from './localisation.coffee'
import VueI18n from 'vue-i18n'


// Internationalisation
Vue.use(VueI18n)
Vue.mixin(localisation)
const en = require('json-loader!yaml-loader!./assets/translations/en.yaml')
const hu = require('json-loader!yaml-loader!./assets/translations/hu.yaml')
const language = (navigator.language || navigator.userLanguage || 'en').split('-')[0]
export const i18n = new VueI18n({
    locale: language,
    fallbackLocale: 'hu',
    silentFallbackWarn: true,
    messages: {
        en: en,
        hu: hu
    }
})


// App
Vue.config.productionTip = false
Vue.config.devtools = false
export default new Vue({
    el: '#app',
    i18n,
    router,
    data: () => { return {homeCallback: ''}},
    render: h => h(App)
})
